interface generateStatsWidgetHtmlProps {
    id:
        | 'shs-oly-olympic-medal-table'
        | 'shs-oly-olympic-schedule'
        | 'shs-oly-olympic-result'
    scriptId: string
}
export function generateStatsWidgetHtml({
    id,
    scriptId,
}: generateStatsWidgetHtmlProps) {
    return `
    <html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Olympic Medal Tally</title>
    <link
      rel="stylesheet"
      type="text/css"
      href="https://widgets-assets.stats.com/css/widgets-${scriptId}.min.css"
    />
  </head>
  <body>
    <style>
      .widget-header{
        display:none;
      }

    </style>
    <div
      id=${id}
      class="olympic-widget"
      data-shs-sport="oly"
      data-shs-league="smr_oly"
      data-shs-client-id="swm"
    ></div>
    <script
      type="text/javascript"
      src="https://widgets-assets.stats.com/shs-widgets/js/core.min.js"
    ></script>
    <script
      type="text/javascript"
      src="https://widgets-assets.stats.com/js/${scriptId}.min.js"
    ></script>


    <script>
      window.onmessage = (e) => {
        document.querySelector(".olympic-widget").style.width =
          e.data.frameWidth;
      };
    </script>
  </body>
</html>
`
}
